import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// Types
type ThemeMode = 'light' | 'dark';
type ScreenSize = 'mobile' | 'tablet' | 'desktop';

interface Modal {
  id: string;
  isOpen: boolean;
  data?: unknown;
}

interface Notification {
  id: string;
  type: 'success' | 'error' | 'warning' | 'info';
  message: string;
  duration?: number;
}

interface UIState {
  theme: ThemeMode;
  screenSize: ScreenSize;
  sidebarOpen: boolean;
  modals: Modal[];
  notifications: Notification[];
  isPageLoading: boolean;
  breadcrumbs: { label: string; path?: string }[];
}

// Initial state
const initialState: UIState = {
  theme: (localStorage.getItem('theme') as ThemeMode) || 'light',
  screenSize: 'desktop',
  sidebarOpen: true,
  modals: [],
  notifications: [],
  isPageLoading: false,
  breadcrumbs: [],
};

// Slice
const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    toggleTheme: state => {
      state.theme = state.theme === 'light' ? 'dark' : 'light';
      localStorage.setItem('theme', state.theme);
    },
    setScreenSize: (state, action: PayloadAction<ScreenSize>) => {
      state.screenSize = action.payload;
      // Auto-close sidebar on mobile
      if (action.payload === 'mobile') {
        state.sidebarOpen = false;
      }
    },
    toggleSidebar: state => {
      state.sidebarOpen = !state.sidebarOpen;
    },
  },
});

export const { toggleTheme, setScreenSize, toggleSidebar } = uiSlice.actions;

export default uiSlice.reducer;
